import ajax from '../http/ajax'

export const getMarketingInfo = (data) => {
    return ajax.get('getMarketingInfo', data)
}
export const getMarketingInfoImgs = (data) => {
    return ajax.get('getMarketingImgs', data)
}
